import React, {use, useCallback, useEffect, useRef, useState} from "react";

import {Link} from "react-router-dom";

import {useNavigate} from "react-router-dom";
import {
    Autocomplete,
    Box,
    Button,
    Card,
    CircularProgress,
    Divider,
    Skeleton,
    Stack,
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@mui/material";
import json2mq from "json2mq";

import {addInfluencerVoting, getPendingPortfolio} from "../../apihelper/addToPortfolio.js";
import "../home/home.css";
import {VerifiedIcon} from "lucide-react";
import "./table.css";

const InfluencerApproval = (props) => {
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [gallarydata, setGallarydata] = useState([]);
    const [loading, setloading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [startIndex, setStartIndex] = useState(0);
    const [addMoregalleryLoader, setAddMoregalleryLoader] = useState(true);

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const handleVotingClick = async (status, portfolio_id, index) => {
        const user_id = userData ? userData.user_id : 0;
        try {
            const response = await addInfluencerVoting({
                user_id,
                portfolio_id,
                action: status,
            });

            if (response.success) {
                setGallarydata((prevData) => {
                    let updatedData = [...prevData];
                    updatedData[index].action = status;
                    return updatedData;
                });
            } else {
                console.error("Voting failed:", response.message || response);
            }
        } catch (error) {
            console.error("API error:", error);
        }
    };

    const StyledTableCell = styled(TableCell)(() => ({
        fontWeight: 500,
        textAlign: "center",
        color: "#727376",
        fontSize: "16px",
        height: "45px",
        background: "white",
        padding: "12px",
        margin: "0 2px 10px 0",
        boxShadow: "0px 2px 17px -4px rgba(45, 54, 67, 0.22)",
        border: "none",
    }));

    const StyledTableRow = styled(TableRow)(() => ({
        // hide last border
        "&:last-child td, &:last-child th": {
            border: 0,
        },
    }));

    const fetchData = useCallback(() => {
        const user_id = userData ? userData.user_id : 0;
        setloading(true);
        try {
            getPendingPortfolio(user_id).then((res) => {
                setGallarydata(res.data);
                setloading(false);
                if (res.data.length < limit) {
                    setAddMoregalleryLoader(false);
                }
            });
        } catch (e) {
            console.error(e);
        }
    });

    useEffect(() => {
        fetchData();
    }, [startIndex]);

    const lastCardRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && addMoregalleryLoader && !loading) {
                    // fetchData(); // Call function when last card is visible
                    setStartIndex(startIndex + limit);
                }
            },
            {threshold: 1.0}
        );

        if (lastCardRef.current) {
            observer.observe(lastCardRef.current);
        }

        return () => {
            if (lastCardRef.current) {
                observer.unobserve(lastCardRef.current);
            }
        };
    }, [gallarydata, addMoregalleryLoader]);

    const tableHeadings = ["Portfolio Name", "Tagged Influencer", "Influencer Ref Link", "Action"];
    return (
        <div className="tagged-approve-section">
            {mediaQueryVar === true && (
                <TableContainer
                    style={{
                        overflowX: "auto",
                        borderRadius: "5px",
                        margin: "0 auto",
                        width: "100%",
                        paddingRight: "30px",
                        marginTop: "-20px",
                    }}
                >
                    <div style={{border: "1px solid #EEE", borderRadius: "5px", overflow: "hidden", width: "100%"}}>
                        <Table
                            className="non_responsiveTable"
                            aria-label="customized table"
                            style={{borderCollapse: "collapse", width: "100%"}}
                        >
                            <TableHead>
                                <TableRow>
                                    {tableHeadings.map((heading, index) => (
                                        <StyledTableCell
                                            className="cryptotableviewHeader"
                                            style={{padding: 0, width: "50vw"}}
                                        >
                                            <button
                                                disabled
                                                style={{
                                                    fontWeight: "500",
                                                    textAlign: "left",
                                                    color: "#727376",
                                                    fontSize: "16px",
                                                    width: "100%",
                                                    height: "45px",
                                                    border: "none",
                                                    background: "white",
                                                    padding: "12px",
                                                    margin: "0 2px 10px 0",
                                                    boxShadow: "0px 2px 17px -4px rgba(45, 54, 67, 0.22)",
                                                    textAlign: index === 0 ? "left" : "center",
                                                }}
                                            >
                                                {heading}
                                            </button>
                                        </StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading === false &&
                                    gallarydata.map((row, index) => (
                                        <TableRow
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? "white" : "#F0F0F0",
                                                cursor: "pointer",
                                            }}
                                            ref={index === gallarydata.length - 1 ? lastCardRef : null}
                                        >
                                            <StyledTableCell
                                                component="th"
                                                scope="row"
                                                style={{
                                                    borderBottom: "none",
                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    paddingLeft: "16px",
                                                    paddingTop: "6px",
                                                    paddingBottom: "6px",
                                                    borderRight: "1px solid #DADEDF",
                                                    backgroundColor: "white",
                                                    wordWrap: "wrap",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        background:
                                                            "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                                        padding: "12px 7px",
                                                        margin: "0 -5px -10px -20px",
                                                    }}
                                                >
                                                    <Box>
                                                        {row.photo ? (
                                                            <img
                                                                src={window.constants.asset_path + row.photo}
                                                                style={{
                                                                    border: "2px solid black",
                                                                    width: "35px",
                                                                    height: "35px",
                                                                    borderRadius: "50%",
                                                                    marginLeft: "5px",
                                                                    marginBottom: "3px",
                                                                }}
                                                                alt="Profile"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={window.constants.asset_path + "/images/avtar.jpeg"}
                                                                style={{
                                                                    width: "38px",
                                                                    height: "38px",
                                                                    borderRadius: "33px",
                                                                    border: "2px solid black",
                                                                    marginLeft: "5px",
                                                                    marginBottom: "3px",
                                                                }}
                                                                alt="Default Avatar"
                                                            />
                                                        )}
                                                    </Box>
                                                    {row.is_verified === "yes" && (
                                                        <VerifiedIcon
                                                            sx={{
                                                                backgroundColor: "white",
                                                                marginTop: "18px",
                                                                borderRadius: "10px",
                                                                color: "#1A91E4",
                                                                fontSize: 20,
                                                                marginLeft: "-15px",
                                                                zIndex: 999,
                                                                flexShrink: 0,
                                                                strokeWidth: "0.5px",
                                                                filter: "dropShadow(0px 2px 5.5px rgba(0, 0, 0, 0.10))",
                                                            }}
                                                        />
                                                    )}
                                                    <Box sx={{marginLeft: "5px"}}>{row.portfolio_type}</Box>
                                                </Box>
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{
                                                    borderBottom: "none",
                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    paddingLeft: "16px",
                                                    paddingTop: "8px",
                                                    paddingBottom: "8px",
                                                    borderRight: "1px solid #DADEDF",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {row.forecaster_name}
                                            </StyledTableCell>

                                            <StyledTableCell
                                                style={{
                                                    borderBottom: "none",
                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    paddingLeft: "16px",
                                                    paddingTop: "8px",
                                                    paddingBottom: "8px",
                                                    borderRight: "1px solid #DADEDF",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Link>{row.influencer_ref_link}</Link>
                                            </StyledTableCell>

                                            <StyledTableCell
                                                style={{
                                                    borderBottom: "none",
                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    paddingLeft: "16px",
                                                    paddingTop: "8px",
                                                    paddingBottom: "8px",
                                                    borderRight: "1px solid #DADEDF",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {row.action ? (
                                                    row.action === "approve" ? (
                                                        <div style={{color: "green"}}>
                                                            <img
                                                                src={
                                                                    window.constants.asset_path +
                                                                    "/images/icons/button_icons/approve-icon.svg"
                                                                }
                                                                alt="Approved"
                                                                style={{
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    marginRight: "5px",
                                                                }}
                                                            />
                                                            Approved{" "}
                                                        </div>
                                                    ) : row.action === "reject" ? (
                                                        <div style={{color: "red"}}>
                                                            <img
                                                                src={
                                                                    window.constants.asset_path +
                                                                    "/images/icons/button_icons/reject-icon.svg"
                                                                }
                                                                alt="reject"
                                                                style={{
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    marginRight: "5px",
                                                                }}
                                                            />
                                                            Rejected
                                                        </div>
                                                    ) : (
                                                        <div style={{color: "red"}}>
                                                            <img
                                                                src={
                                                                    window.constants.asset_path +
                                                                    "/images/icons/button_icons/abstain-icon.svg"
                                                                }
                                                                alt="reject"
                                                                style={{
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    marginRight: "5px",
                                                                }}
                                                            />
                                                            Abstain
                                                        </div>
                                                    )
                                                ) : (
                                                    <div style={{display: "flex", gap: "5px"}}>
                                                        <button
                                                            className="btn btn-approve d-flex"
                                                            onClick={() =>
                                                                handleVotingClick("approve", row.portfolio_id, index)
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    window.constants.asset_path +
                                                                    "/images/icons/button_icons/approve-icon.svg"
                                                                }
                                                                alt="Approved"
                                                                style={{
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    marginRight: "5px",
                                                                }}
                                                            />
                                                            Approve
                                                        </button>
                                                        <button
                                                            className="btn btn-reject d-flex"
                                                            onClick={() =>
                                                                handleVotingClick("reject", row.portfolio_id, index)
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    window.constants.asset_path +
                                                                    "/images/icons/button_icons/reject-icon.svg"
                                                                }
                                                                alt="reject"
                                                                style={{
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    marginRight: "5px",
                                                                }}
                                                            />
                                                            Reject
                                                        </button>
                                                        <button
                                                            className="btn btn-abstrain d-flex"
                                                            onClick={() =>
                                                                handleVotingClick("abstain", row.portfolio_id, index)
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    window.constants.asset_path +
                                                                    "/images/icons/button_icons/abstain-icon.svg"
                                                                }
                                                                alt="Abstain"
                                                                style={{
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    marginRight: "5px",
                                                                }}
                                                            />
                                                            Abstain
                                                        </button>
                                                    </div>
                                                )}
                                            </StyledTableCell>
                                        </TableRow>
                                    ))}

                                {loading === true &&
                                    [...Array(5)].map((idx) => (
                                        <StyledTableRow key={idx}>
                                            <StyledTableCell>
                                                <Stack>
                                                    <Skeleton variant="rounded" sx={{marginTop: "10px"}} height={40} />
                                                </Stack>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <Stack>
                                                    <Skeleton variant="rounded" sx={{marginTop: "10px"}} height={40} />
                                                </Stack>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <Stack>
                                                    <Skeleton variant="rounded" sx={{marginTop: "10px"}} height={40} />
                                                </Stack>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <Stack>
                                                    <Skeleton variant="rounded" sx={{marginTop: "10px"}} height={40} />
                                                </Stack>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            )}

            {mediaQueryVar === false && (
                <div>
                    <TableContainer
                        sx={{
                            borderRadius: "10px",
                            maxHeight: "auto",
                            overflowX: "hidden",
                            overflowY: "auto",
                            padding: "0px 4%",
                            marginBottom: "0px",
                            width: "100%",
                            "&::-webkit-scrollbar": {
                                display: "none",
                            },
                            // Hides scrollbar for Firefox
                            scrollbarWidth: "none",
                            paddingTop: "0px",
                        }}
                    >
                        {/* <div
                                            style={{
                                                marginLeft: "0px",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                width: "100%",
                                                justifyContent: "space-between", // Evenly spaces hashtags across rows
                                                gap: "10px", // Adds consistent spacing
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {hashtags.map((tag, index) => {
                                                const isSelected = selectedHashtags.includes(tag);
                                                return (
                                                    <span
                                                        key={index}
                                                        onClick={() => toggleHashtag(tag)}
                                                        style={{
                                                            cursor: "pointer",
                                                            padding: mediaQueryVar2 ? "4px 4px" : "4px 8px",
                                                            fontSize: mediaQueryVar2 ? "12px" : "14px",
                                                            fontWeight: "500",
                                                            borderRadius: "6px",
                                                            transition: "all 0.3s ease",
                                                            width: "auto", // Ensures max 3 items per row
                                                            textAlign: "center",
                                                            backgroundColor: isSelected ? "#1877f2" : "white",
                                                            color: isSelected ? "white" : "#1877f2",
                                                            border: isSelected ? "none" : "1px solid #1877f2",
                                                        }}
                                                    >
                                                        {tag}
                                                    </span>
                                                );
                                            })}
                                        </div> */}
                        {loading === true && (
                            <TableBody>
                                {[...Array(5)].map((idx) => (
                                    <StyledTableRow key={idx}>
                                        <Box
                                            sx={{
                                                width: "91vw", // Card width
                                                padding: 2,
                                                borderRadius: 2, // Border radius for the card
                                                boxShadow: 1, // Card shadow
                                                margin: "10px 0px",
                                                backgroundColor: "background.paper",
                                            }}
                                        >
                                            {/* Row 1: Image on the left, text on the right */}
                                            <Stack direction="row" spacing={2} alignItems="center">
                                                <Skeleton variant="circular" width={60} height={60} />
                                                <Stack spacing={1} width="100%">
                                                    <Skeleton variant="text" height={20} />
                                                    <Skeleton variant="text" height={20} width="80%" />
                                                </Stack>
                                            </Stack>

                                            {/* Row 2, 3, 4: Full-width text */}
                                            <Stack spacing={1} mt={2}>
                                                <Skeleton variant="text" height={20} />
                                                <Skeleton variant="text" height={20} />
                                                <Skeleton variant="text" height={20} />
                                            </Stack>
                                        </Box>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        )}
                        {!loading && (
                            <Stack>
                                {gallarydata.map((row, index) => (
                                    <Card
                                        key={index}
                                        sx={{marginBottom: "10px", marginLeft: "0px", boxShadow: "none"}}
                                        ref={index === gallarydata.length - 1 ? lastCardRef : null} // Attach ref to last card
                                    >
                                        <Box
                                            sx={{
                                                borderRadius: "6px",
                                                marginTop: "9px",
                                                marginBottom: "9px",
                                                marginLeft: "7px",
                                                marginRight: "0px",
                                                paddingTop: "3px",
                                                paddingBottom: "3px",
                                                paddingLeft: "5px",
                                                paddingRight: "5px",
                                                border: "1px solid #DADEDF",
                                                background:
                                                    "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                                minheight: "150px",
                                            }}
                                        >
                                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                                <Box>
                                                    {row.photo ? (
                                                        <img
                                                            src={window.constants.asset_path + row.photo}
                                                            style={{
                                                                width: "38px",
                                                                height: "38px",
                                                                borderRadius: "33px",
                                                                border: "2px solid black",
                                                            }}
                                                            alt="Profile Pic"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={window.constants.asset_path + "/images/avtar.jpeg"}
                                                            style={{
                                                                width: "38px",
                                                                height: "38px",
                                                                borderRadius: "33px",
                                                                border: "2px solid black",
                                                                marginLeft: "3px",
                                                            }}
                                                            alt="Default Profile Pic"
                                                        />
                                                    )}
                                                </Box>

                                                {row.is_verified === "yes" && (
                                                    <VerifiedIcon
                                                        sx={{
                                                            color: "#1877F2",
                                                            fontSize: 20,
                                                            zIndex: 999,
                                                            marginTop: "22px",
                                                            marginLeft: "-15px",
                                                            background: "white",
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                )}

                                                <Box sx={{flexGrow: 1}}>
                                                    <Stack direction="row" justifyContent="space-between">
                                                        <Box style={{position: "relative"}}>
                                                            <Typography
                                                                variant="h6"
                                                                sx={{
                                                                    color: "black",
                                                                    fontWeight: "500",
                                                                    fontSize: "16px",
                                                                    padding: "10px",
                                                                    fontFamily: "Satoshi,sans-serif",
                                                                    filter: "none",
                                                                }}
                                                            >
                                                                {row.portfolio_type}
                                                            </Typography>
                                                        </Box>

                                                        <Typography variant="body2">
                                                            <img
                                                                src={`${window.constants.asset_path}/images/link.svg`} // Example path
                                                                alt="Link Symbol"
                                                                style={{
                                                                    width: "10px",
                                                                    height: "15px",
                                                                    marginLeft: "8px",
                                                                }}
                                                            />
                                                        </Typography>
                                                    </Stack>
                                                </Box>
                                            </Stack>
                                        </Box>

                                        <Divider sx={{my: 1}} />

                                        <Box
                                            sx={{
                                                background: "white",
                                                borderRadius: "6px",
                                                marginTop: "0px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                                minHeight: "auto",
                                                padding: "8px",
                                                border: "1px solid #1877F2",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                <Box sx={{display: "flex", alignItems: "center"}}>
                                                    {row.action ? (
                                                        row.action === "approve" ? (
                                                            <div style={{color: "green"}}>
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path +
                                                                        "/images/icons/button_icons/approve-icon.svg"
                                                                    }
                                                                    alt="Approved"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                Approved{" "}
                                                            </div>
                                                        ) : row.action === "reject" ? (
                                                            <div style={{color: "red"}}>
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path +
                                                                        "/images/icons/button_icons/reject-icon.svg"
                                                                    }
                                                                    alt="reject"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                Rejected
                                                            </div>
                                                        ) : (
                                                            <div style={{color: "red"}}>
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path +
                                                                        "/images/icons/button_icons/abstain-icon.svg"
                                                                    }
                                                                    alt="reject"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                Abstain
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div style={{display: "flex", gap: "5px"}}>
                                                            <button
                                                                className="btn btn-approve d-flex"
                                                                onClick={() =>
                                                                    handleVotingClick(
                                                                        "approve",
                                                                        row.portfolio_id,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path +
                                                                        "/images/icons/button_icons/approve-icon.svg"
                                                                    }
                                                                    alt="Approved"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                Approve
                                                            </button>
                                                            <button
                                                                className="btn btn-reject d-flex"
                                                                onClick={() =>
                                                                    handleVotingClick("reject", row.portfolio_id, index)
                                                                }
                                                            >
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path +
                                                                        "/images/icons/button_icons/reject-icon.svg"
                                                                    }
                                                                    alt="reject"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                Reject
                                                            </button>
                                                            <button
                                                                className="btn btn-abstrain d-flex"
                                                                onClick={() =>
                                                                    handleVotingClick(
                                                                        "abstain",
                                                                        row.portfolio_id,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src={
                                                                        window.constants.asset_path +
                                                                        "/images/icons/button_icons/abstain-icon.svg"
                                                                    }
                                                                    alt="Abstain"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        marginRight: "5px",
                                                                    }}
                                                                />
                                                                Abstain
                                                            </button>
                                                        </div>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: "white",
                                                borderRadius: "6px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                                minHeight: "auto",
                                                padding: "6px",
                                                borderTop: "none",
                                                borderBottom: "1px solid #1877F2",
                                                borderLeft: "1px solid #1877F2",
                                                borderRight: "1px solid #1877F2",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#76787A",
                                                        fontWeight: "500",
                                                        fontSize: "13px",
                                                        fontFamily: "Satoshi, Arial, sans-serif",
                                                        marginTop: "5px",
                                                        marginLeft: "2px",
                                                    }}
                                                >
                                                    Influencer Name:{" "}
                                                    <span
                                                        style={{
                                                            color: "black",
                                                            fontWeight: "500",
                                                            fontSize: "14px",
                                                            paddingLeft: "10px",
                                                        }}
                                                    >
                                                        {row.forecaster_name}
                                                    </span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: "white",
                                                borderRadius: "6px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                                minHeight: "auto",
                                                padding: "6px",
                                                borderTop: "none",
                                                borderBottom: "1px solid #1877F2",
                                                borderLeft: "1px solid #1877F2",
                                                borderRight: "1px solid #1877F2",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#76787A",
                                                        fontWeight: "500",
                                                        fontSize: "13px",
                                                        fontFamily: "Satoshi, Arial, sans-serif",
                                                        marginTop: "5px",
                                                        marginLeft: "2px",
                                                    }}
                                                >
                                                    Influencer Ref Link:{" "}
                                                    <span
                                                        style={{
                                                            color: "black",
                                                            fontWeight: "500",
                                                            fontSize: "14px",
                                                            paddingLeft: "10px",
                                                        }}
                                                    >
                                                        <a
                                                            href={`${row.influencer_ref_link}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {row.influencer_ref_link}
                                                        </a>{" "}
                                                    </span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                ))}
                            </Stack>
                        )}
                        {gallarydata.length === 0 && loading && (
                            <Typography align="center" variant="h6">
                                No Data Found
                            </Typography>
                        )}
                        <Box sx={{textAlign: "center", mt: 2, pb: 10}}>
                            {addMoregalleryLoader && <CircularProgress color="primary" />}
                        </Box>
                    </TableContainer>
                </div>
            )}
        </div>
    );
};

export default InfluencerApproval;
